"use client";

import { useTransition, type FormEvent, type ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { Button } from './Button';

/** GET fallback works before hydration; hydrated navigation exposes pending state. */
export function DirectorySearchForm({ action, label, children }: { action: string; label: string; children: ReactNode }) {
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const query = new URLSearchParams();
    for (const [key, value] of new FormData(event.currentTarget)) {
      if (typeof value === 'string') query.append(key, value);
    }
    startTransition(() => router.push(`${action}?${query.toString()}`));
  }
  return <form action={action} method="get" role="search" onSubmit={submit} aria-busy={pending || undefined} className="grid w-full gap-3 sm:grid-cols-[minmax(0,1fr)_auto] sm:items-end">
    {children}
    <Button type="submit" size="lg" loading={pending} loadingLabel="Searching…">{label}</Button>
  </form>;
}
